var React = require('react');

function FacebookCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22 0H0v22h9.938v-8.007H8v-2.197h1.938v-1.208c0-1.464.392-2.595 1.175-3.392.783-.797 1.88-1.196 3.29-1.196.5 0 1.033.073 1.597.22l-.07 2.318a5.418 5.418 0 00-1.093-.097c-1.363 0-2.044.728-2.044 2.184v1.171h2.584v2.197h-2.584V22H22V0z","fill":"currentColor"}));
}

FacebookCircle.defaultProps = {"fill":"none","viewBox":"0 0 22 22"};

module.exports = FacebookCircle;

FacebookCircle.default = FacebookCircle;
